const ReportedItems = () => {
  return <></>;
};

export default ReportedItems;
